// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"de3b607f","787":"87cfb0e8"}[chunkId] + ".chunk.js";
};